// import sftp from './sftp';
// import git from './git';
import s3 from './s3';

export default {
    s3
    // sftp,
    // git
};
